import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { Act48ReportHelpersService } from 'src/app/services/a48-report-helpers/a48-report-helpers.service';
import { Act48ReportService } from 'src/app/services/a48-report.service';
import { A48PrintParaReportComponent } from './a48-para-print-report/a48-para-print-report.component';

export function getReportRequest(act48ReportHelpersService: Act48ReportHelpersService, transition: Transition) {
    const params = transition.params();
    const { userID, startDate, endDate, type, perms, itemSubType, showDetails } = params;
    return act48ReportHelpersService.getReportRequest({ userID, startDate, endDate, type, 
        perms, itemSubType, showDetails, shouldGetAll: true });
}

export function resolveReportContent(act48ReportHelpersService: Act48ReportHelpersService, act48ReportService: Act48ReportService, transition: Transition) {
    const request = getReportRequest(act48ReportHelpersService, transition);
    return act48ReportService
        .getParaeducatorReport(request)
        .toPromise();
}

export let A48PrintReportStates: Ng2StateDeclaration[] = [{
    name: 'print.reports',
    url: '/reports',
    abstract: true
},{
    name: 'print.reports.a48_paraeducator',
    url: '/a48/paraeducator?userID&startDate&endDate&type&perms&itemSubType&showDetails',
    views: {
        'content@print': {
            component: A48PrintParaReportComponent
        }
    },
    params: {
        type: {
            type: 'int'
        },
        perms: {
            type: 'int'
        },
        itemSubType: {
            type: 'int'
        },
    },
    resolve: [{
        token: 'pagedResponse',
        deps: [Act48ReportHelpersService, Act48ReportService, Transition],
        resolveFn: resolveReportContent,
    },
    {
        token: 'request',
        deps: [Act48ReportHelpersService, Transition],
        resolveFn: getReportRequest
    }]
}];